export function Donut({ percent, label }: { percent: number; label: string }) {
  const r = 26;
  const c = 2 * Math.PI * r;
  const offset = c * (1 - percent / 100);
  return (
    <div className="flex items-center gap-3">
      <svg width="72" height="72" viewBox="0 0 72 72">
        <circle cx="36" cy="36" r={r} fill="none" stroke="rgba(0,0,0,0.08)" strokeWidth="6" />
        <circle
          cx="36"
          cy="36"
          r={r}
          fill="none"
          stroke="var(--color-accent)" data-accent-redundant
          strokeWidth="6"
          strokeDasharray={c}
          strokeDashoffset={offset}
          transform="rotate(-90 36 36)"
          strokeLinecap="round"
        />
        <text x="36" y="38" textAnchor="middle" dominantBaseline="middle" fontSize="14" fontWeight="600">
          {percent}%
        </text>
      </svg>
      <div className="smycles-field-label">{label}</div>
    </div>
  );
}
